/**
 * Update date: 2025-06-04
 * Screen 2048.3
 */
import { BreadCrumbPremium } from 'app/components/BreadCrumbPremium';
import LoadPanel from 'app/components/LoadPanel';
import { NotFoundPage } from 'app/components/NotFoundPage';
import useAxios from 'axios-hooks';
import { ROW_STATUS } from 'constant';
import TabPanel, { Item } from 'devextreme-react/tab-panel';
import useDictionary from 'hooks/useDictionary';
import React, { createContext, useContext, useState } from 'react';
import { notification } from 'utils/notification';

const FormSearch = React.lazy(() => import('./FormSearch'));
const Tab1 = React.lazy(() => import('./Tab1'));
const Tab2 = React.lazy(() => import('./Tab2'));
const Tab2Edit = React.lazy(() => import('./Tab2Edit'));

/**
 * create context
 */
const ModuleContext = createContext({});
ModuleContext.displayName = 'M2048_3Context';
export const useModuleContext = () => {
  return useContext(ModuleContext);
};

export default function M2048_3() {
  const { t }: any = useDictionary({ programId: '2048.3' });
  const [selectedIndex, setSelectedIndex] = useState(0);
  const [dataTab1, setDataTab1] = useState<any>([]);
  const [dataTab2, setDataTab2] = useState<any>([]);
  const [modeView, setModeView] = useState<any>({
    type: 'list',
    data: null,
  });
  const [formData, setFormData] = useState<any>({
    fromDate: new Date(),
    endDate: new Date(),
    dataList: {
      zone: [],
    },
    zone: '',
  });
  const [storedDataSearch, setStoredDataSearch] = useState<any>(null);

  const [{ loading }, refetchSearch] = useAxios(
    {},
    { manual: true, autoCancel: true },
  );

  /**
   * on search submit
   *
   * @param {*} params
   */
  const onSearchSubmit = async params => {
    if (!params && storedDataSearch) {
      params = storedDataSearch;
    }
    const res: any = await refetchSearch({
      url: 'warehouse/m2048_3/get-zone-move',
      method: 'POST',
      data: params,
    });

    if (res?.data?.status === '200') {
      setStoredDataSearch({ ...params });
      const { details, bills } = res?.data?.data || {};
      setDataTab1(
        (details || []).map(o => ({
          ...o,
          status: ROW_STATUS.NORMAL,
        })),
      );
      setDataTab2(bills || []);
    } else {
      notification({ res });
    }
  };

  /**
   * on select index
   *
   * @param {*} e
   */
  const onSelectedIndexChange = e => {
    setSelectedIndex(e);
  };

  /**
   * render content
   *
   * @return {*}
   */
  const renderContent = () => {
    switch (modeView?.type) {
      case 'list':
        return (
          <>
            <BreadCrumbPremium />
            <FormSearch />
            <TabPanel
              deferRendering={false}
              swipeEnabled={false}
              repaintChangesOnly
              showNavButtons
              defaultSelectedIndex={0}
              selectedIndex={selectedIndex}
              onSelectedIndexChange={onSelectedIndexChange}
              className="bg-white"
            >
              <Item title={t('Zone To Zone Move Detail')}>
                <Tab1 dataTab1={dataTab1} onSearchSubmit={onSearchSubmit} />
              </Item>
              <Item title={t('Zone To Zone Move Bill')}>
                <Tab2
                  dataTab2={dataTab2}
                  setModeView={setModeView}
                  onSearchSubmit={onSearchSubmit}
                />
              </Item>
            </TabPanel>
          </>
        );
      case 'edit':
        return <Tab2Edit />;
      default:
        return <NotFoundPage />;
    }
  };

  const valueContext = {
    modeView,
    setModeView,
    formData,
    setFormData,
    onSearchSubmit,
  };

  return (
    <ModuleContext.Provider value={valueContext}>
      <React.Suspense fallback={<LoadPanel visible={true} />}>
        <LoadPanel visible={loading} />
        {renderContent()}
      </React.Suspense>
    </ModuleContext.Provider>
  );
}
